module.exports = __webpack_public_path__ + "img/frame (64).e0634921.jpg";